/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Leads from "./pages/Leads";
import LeadDetail from "./pages/LeadDetail";
import Pipeline from "./pages/Pipeline";
import Settings from "./pages/Settings";
import ProblemReports from "./pages/ProblemReports";
import Pricing from "./pages/Pricing";
import Checkout from "./pages/Checkout";
import Unsubscribe from "./pages/Unsubscribe";
import FollowUps from "./pages/FollowUps";
import ImportLeads from "./pages/ImportLeads";
import Login from "./pages/Login";
import Onboarding from "./pages/Onboarding";
import MapPage from "./pages/Map";
import Opportunities from "./pages/Opportunities";
import DriveForDollars from "./pages/DriveForDollars";
import Contracts from "./pages/Contracts";
import ChatWithPipeline from "./pages/ChatWithPipeline";
import SignalsAndOutreach from "./pages/SignalsAndOutreach";
import { useAppStore } from "./store/useAppStore";
import { FirebaseProvider } from "./components/FirebaseProvider";

export default function App() {
  const { isAuthenticated, hasCompletedOnboarding } = useAppStore();

  return (
    <FirebaseProvider>
      <Router>
        <Routes>
          <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to={hasCompletedOnboarding ? "/" : "/onboarding"} />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/checkout/:planId" element={<Checkout />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/onboarding" element={isAuthenticated && !hasCompletedOnboarding ? <Onboarding /> : <Navigate to={isAuthenticated ? "/" : "/login"} />} />
          
          {/* Protected Routes */}
          <Route path="/" element={isAuthenticated && hasCompletedOnboarding ? <Layout /> : <Navigate to={!isAuthenticated ? "/login" : "/onboarding"} />}>
            <Route index element={<Dashboard />} />
            <Route path="leads" element={<Leads />} />
            <Route path="leads/:id" element={<LeadDetail />} />
            <Route path="opportunities" element={<Opportunities />} />
            <Route path="map" element={<MapPage />} />
            <Route path="pipeline" element={<Pipeline />} />
            <Route path="follow-ups" element={<FollowUps />} />
            <Route path="import" element={<ImportLeads />} />
            <Route path="drive-for-dollars" element={<DriveForDollars />} />
            <Route path="contracts" element={<Contracts />} />
            <Route path="signals" element={<SignalsAndOutreach />} />
            <Route path="ask" element={<ChatWithPipeline />} />
            <Route path="settings" element={<Settings />} />
            <Route path="problem-reports" element={<ProblemReports />} />
          </Route>
        </Routes>
      </Router>
    </FirebaseProvider>
  );
}
